// Generated by purs version 0.15.12
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Control_Monad_Writer_Trans from "../Control.Monad.Writer.Trans/index.js";
import * as Data_DateTime_Instant from "../Data.DateTime.Instant/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT);
var lift1 = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT);
var lift2 = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_State_Trans.monadTransStateT);
var monadTimeAff = {
    delay: /* #__PURE__ */ (function () {
        var $46 = Data_Time_Duration.convertDuration(Fusion_Data_Duration.durationDuration)(Data_Time_Duration.durationMilliseconds);
        return function ($47) {
            return Effect_Aff.delay($46($47));
        };
    })(),
    now: /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(/* #__PURE__ */ Data_Functor.map(Effect.functorEffect)(/* #__PURE__ */ (function () {
        var $48 = Data_Time_Duration.convertDuration(Data_Time_Duration.durationMilliseconds)(Fusion_Data_Duration.durationDuration);
        return function ($49) {
            return Fusion_Data_Timestamp.timeIntervalSince1970($48(Data_DateTime_Instant.unInstant($49)));
        };
    })())(Effect_Now.now)),
    Monad0: function () {
        return Effect_Aff.monadAff;
    }
};
var now = function (dict) {
    return dict.now;
};
var delay = function (dict) {
    return dict.delay;
};
var monadTimeExceptT = function (dictMonadTime) {
    var Monad0 = dictMonadTime.Monad0();
    var lift3 = lift(Monad0);
    var monadExceptT = Control_Monad_Except_Trans.monadExceptT(Monad0);
    return {
        delay: (function () {
            var $50 = delay(dictMonadTime);
            return function ($51) {
                return lift3($50($51));
            };
        })(),
        now: lift3(now(dictMonadTime)),
        Monad0: function () {
            return monadExceptT;
        }
    };
};
var monadTimeReaderT = function (dictMonadTime) {
    var Monad0 = dictMonadTime.Monad0();
    var lift3 = lift1(Monad0);
    var delay1 = delay(dictMonadTime);
    var monadReaderT = Control_Monad_Reader_Trans.monadReaderT(Monad0);
    return {
        delay: function (duration) {
            return lift3(delay1(duration));
        },
        now: lift3(now(dictMonadTime)),
        Monad0: function () {
            return monadReaderT;
        }
    };
};
var monadTimeStateT = function (dictMonadTime) {
    var Monad0 = dictMonadTime.Monad0();
    var lift3 = lift2(Monad0);
    var delay1 = delay(dictMonadTime);
    var monadStateT = Control_Monad_State_Trans.monadStateT(Monad0);
    return {
        delay: function (duration) {
            return lift3(delay1(duration));
        },
        now: lift3(now(dictMonadTime)),
        Monad0: function () {
            return monadStateT;
        }
    };
};
var monadTimeWriterT = function (dictMonoid) {
    var lift3 = Control_Monad_Trans_Class.lift(Control_Monad_Writer_Trans.monadTransWriterT(dictMonoid));
    var monadWriterT = Control_Monad_Writer_Trans.monadWriterT(dictMonoid);
    return function (dictMonadTime) {
        var Monad0 = dictMonadTime.Monad0();
        var lift4 = lift3(Monad0);
        var delay1 = delay(dictMonadTime);
        var monadWriterT1 = monadWriterT(Monad0);
        return {
            delay: function (duration) {
                return lift4(delay1(duration));
            },
            now: lift4(now(dictMonadTime)),
            Monad0: function () {
                return monadWriterT1;
            }
        };
    };
};
export {
    delay,
    now,
    monadTimeExceptT,
    monadTimeAff,
    monadTimeReaderT,
    monadTimeWriterT,
    monadTimeStateT
};
